import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../shared/components/header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ScrollToTopDirective } from '../shared/directives/button-to-top.directive';
import { ActivatingMenuService } from '../shared/services/activating-menu.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    ScrollToTopDirective,
  ],
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  sidebarCollapsed: boolean = false;
  private sub = new Subscription();

  constructor(private activatingMenuService: ActivatingMenuService) {}

  ngOnInit(): void {
    this.sub.add(
      this.activatingMenuService.sidebarCollapsed$.subscribe(collapsed => {
        this.sidebarCollapsed = collapsed;
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
